import { render, staticRenderFns } from "./MerchantsOffers.vue?vue&type=template&id=31772d58&scoped=true"
import script from "./MerchantsOffers.vue?vue&type=script&lang=js"
export * from "./MerchantsOffers.vue?vue&type=script&lang=js"
import style0 from "./MerchantsOffers.vue?vue&type=style&index=0&id=31772d58&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31772d58",
  null
  
)

export default component.exports